import { render, staticRenderFns } from "./inboundCard.vue?vue&type=template&id=a00115fa&scoped=true&"
import script from "./inboundCard.vue?vue&type=script&lang=ts&"
export * from "./inboundCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00115fa",
  null
  
)

export default component.exports